// agentCountSlice.ts
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface Filter {
  name: string;
  filterByConditions: { [key: string]: any };
}

export interface AgentCount {
  totalCount: number;
  filteredCount: number;
}

export interface AgentCountState {
  agentCount: AgentCount | null;
  loading: boolean;
  error: string | null;
  savedCount: any;
}

export interface FetchAgentCountAction {
  type: string; // This could be the action type (e.g., 'FETCH_AGENT_COUNT')
  payload: {
    columns: Filter[] | [];
    supervisorId: string;
  };
}

export const agentCountInitialState: AgentCountState = {
  agentCount: null,
  loading: false,
  error: null,
  savedCount: null,
};

const agentCountSlice = createSlice({
  name: 'agentCount',
  initialState: agentCountInitialState,
  reducers: {
    fetchAgentCount(state, action: PayloadAction<{ columns: Filter[] }>) {
      state.loading = true;
      state.error = null;
    },
    fetchAgentCountSuccess(state, action: PayloadAction<AgentCount>) {
      state.loading = false;
      state.agentCount = action.payload;
    },
    fetchAgentCountFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchAgentCount,
  fetchAgentCountSuccess,
  fetchAgentCountFailure,
} = agentCountSlice.actions;

export default agentCountSlice.reducer;
